import { useState } from "react";
import CloseIcon from "./../../assets/icons/close.svg?react";
import {
  Button,
  Typography,
  getLocalStorage,
  setLocalStorage,
} from "djuno-design";

const Web3Banner = () => {
  const docsUrl = import.meta.env.VITE_DOCS_URL || "";
  const showWeb3Banner = getLocalStorage<boolean>("web3-banner", true);
  const [show, setShow] = useState<boolean>(showWeb3Banner);
  const closeBanner = () => {
    setLocalStorage<boolean>("web3-banner", false);
    setShow(false);
  };

  if (!show) return null;
  return (
    <div className="relative w-full mt-5 bg-gray-50 dark:bg-dark-3 border border-slate-300 dark:border-dark-2 p-6 rounded-lg flex flex-col">
      <CloseIcon
        onClick={closeBanner}
        className="absolute right-3 top-3 text-slate-500 dark:text-slate-300 w-5 hover:scale-110 duration-300 cursor-pointer"
      />
      <div className="flex items-center w-full justify-between">
        <Typography.Text className="!text-sm">
          Get started with Web3.0 API
        </Typography.Text>
      </div>
      <div className="flex items-center flex-wrap gap-2 mt-5">
        <a
          href={docsUrl + "/en/articles/10108332-web3-0-auth-service"}
          target="_blank"
          rel="noreferrer"
        >
          <Button>Documentation</Button>
        </a>
        <a
          href={docsUrl + "/en/articles/10108332-web3-0-auth-service"}
          target="_blank"
          rel="noreferrer"
        >
          <Button>Sign in with Metamask</Button>
        </a>
        <a
          href={docsUrl + "/en/articles/10108332-web3-0-auth-service"}
          target="_blank"
          rel="noreferrer"
        >
          <Button>Aggregate user data</Button>
        </a>
      </div>
    </div>
  );
};

export default Web3Banner;
